module.exports = __webpack_public_path__ + "img/e416d79.png";